import axios from "axios";
import API from "../services/base_url";
import { getToken } from "../utils/auth";
//import { getToken } from "../utils/auth";

export const getAdminStats = async (token) => {
  try {
    const response = await axios.get(
      `https://aceswafund.org/welfare/welfare-system/get_dashboard_stats`,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
           'Content-Type': 'application/json',
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': '0'
        },
      }
    );

    if (response.data.status) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, error: "Failed to load stats" };
    }
  } catch (error) {
    console.error("Dashboard Stats Error:", error);
    return { success: false, error: "Server error loading dashboard stats" };
  }
};

export const getAdminDashboardSummary = async (token) => {
  try {
    const res = await axios.get(
      `https://aceswafund.org/welfare/welfare-system/get_dashboard_stats`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    console.log("📊 Raw API Response TO SEE:", JSON.stringify(res.data));
    console.log("📊 Response Data:", res.data);

    if (res.data.status === 200) {
      // Return the data directly - don't wrap it
      return res.data;
    } else {
      console.error("API returned error:", res.data);
      return { 
        status: false, 
        error: res.data?.message || "Failed to fetch dashboard summary" 
      };
    }
  } catch (error) {
    console.error("API Error:", error);
    return {
      status: false,
      error:
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Something went wrong",
    };
  }
};

export const getPendingNotifications = async (token) => {
  try {
    const res = await axios.get(
      "https://aceswafund.org/welfare/welfare-system/admin-pending-notifications",
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res.data.status) {
      return { status: true, data: res.data.data };
    } else {
      return { status: false, error: "Failed to fetch notifications" };
    }
  } catch (err) {
    return { status: false, error: "Failed to fetch notifications" };
  }
};

export const getAllContributions = async (token, page = 1, limit = 10, search = "") => {
  try {
    console.log("Making API request with:", { page, limit, search });
    
    // Add timestamp to prevent caching
    const timestamp = Date.now();
    const url = `https://aceswafund.org/welfare/welfare-system/get_all_contributions?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}&_=${timestamp}`;
    console.log("Request URL:", url);
    
    const res = await axios.get(url, {
      headers: { 
        'Authorization': `Bearer ${token}`,
         'Content-Type': 'application/json',
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': '0'
      }
    });
    
    console.log("Raw API response:", res);
    console.log("Response data:", res.data);
    
    return res.data;
  } catch (err) {
    console.log("Error fetching contributions:", err);
    if (err.response) {
      console.log("Error response data:", err.response.data);
      console.log("Error response status:", err.response.status);
    }
    return { status: false, error: "Failed to fetch contributions" };
  }
};

// admin_api.js or your API helper file
export const updateContribution = async (userId, contributionId, data, token) => {
  try {
    console.log("Updating contribution:", { userId, contributionId, data });
    
    // Use POST with query parameter for user_id
    const response = await axios.post(
      `https://aceswafund.org/welfare/welfare-system/update_contribution?user_id=${userId}`,
      {
        contribution_id: contributionId,
        amount: data.amount,
        category: data.category,
        status: data.status
      },
      {
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    
    console.log("Update API response:", response);
    console.log("Update API data:", response.data);
    
    return response.data;
  } catch (err) {
    console.error("Update API error:", err);
    
    if (err.response) {
      console.log("Error response data:", err.response.data);
      return err.response.data || { 
        success: false, 
        error: err.response.data?.message || "Update failed" 
      };
    }
    return { success: false, error: "Network error" };
  }
};



// Updated getAllUsers function with better error handling and return type
export const getAllUsers = async (token, page = 1, limit = 100) => {
  try {
    const res = await axios.get(
      `https://aceswafund.org/welfare/welfare-system/admin-get-users?page=${page}&limit=${limit}`,
      {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json',
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': '0' },
      }
    );

    console.log("USER DATA API RESPONSE:", res.data);

    // Handle different response structures
    let users = [];

    // Check various possible response structures
    if (res.data?.users && Array.isArray(res.data.users)) {
      // Structure: { users: { data: [], ...pagination } }
      users = res.data.users;
    } else if (res.data?.data && Array.isArray(res.data.data)) {
      // Structure: { data: [] }
      users = res.data.data;
    } else if (Array.isArray(res.data)) {
      // Structure: [] (direct array)
      users = res.data;
    } else if (res.data?.users && Array.isArray(res.data.users)) {
      // Structure: { users: [] }
      users = res.data.users;
    } else if (res.data?.status && res.data?.users) {
      // Structure: { status: true, users: [] }
      users = Array.isArray(res.data.users) ? res.data.users : [];
    }

    // Return consistent structure
    return {
      status: true,
      users: users,
      rawResponse: res.data, // Keep original for debugging
      pagination: res.data?.pagination || res.data?.users?.pagination || null,
    };
  } catch (err) {
    console.error("Error fetching users:", err);
    return {
      status: false,
      error: err.response?.data?.message || "Failed to fetch users",
      users: [],
    };
  }
};

// ✅ Delete user
export const deleteUser = async (token, userId) => {
  try {
    const res = await axios.delete(
      `https://aceswafund.org/welfare/welfare-system/admin-delete-user/${userId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return res.data;
  } catch (err) {
    return { status: false, error: "Failed to delete user" };
  }
};
//make user admin
export const makeUserAdmin = async (token, userId) => {
  try {
    const res = await API.post(
      `/welfare/welfare-system/make-admin`,
      { user_id: userId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (err) {
    console.error("Promote user error:", err);
    return { status: false, error: "Failed to promote user" };
  }
};

// ✅ Demote admin back to normal user
export const makeUserNormal = async (token, userId) => {
  try {
    const res = await API.post(
      `/welfare/welfare-system/make-user?user_id=${userId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (err) {
    return { status: false, error: "Failed to demote user" };
  }
};

export const deleteContribution = async (contributionId, user_id, token) => {
  try {
    const res = await API.post(
      `/welfare/welfare-system/delete_contribution`, 
      {
        contribution_id: contributionId,
        user_id: user_id,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    console.log("Delete API Response:", res.data); // Debug log

    // Based on your working pattern from getAdminDashboardSummary
    if (res.status === 200 && res.data.status) {
      return {
        success: true,
        status: true,
        data: res.data,
        message: res.data?.message || "Contribution deleted successfully",
      };
    } else {
      return {
        success: false,
        status: false,
        error: res.data?.message || "Failed to delete contribution",
        data: res.data,
      };
    }
  } catch (error) {
    console.error("Delete contribution error:", error);

    return {
      success: false,
      status: false,
      error:
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Something went wrong",
      statusCode: error.response?.status,
    };
  }
};

export const exportContributions = async (
  { page = 1, limit = 1000, search = "", status = "" } = {},
  token
) => {
  try {
    const res = await API.post(
      "/welfare/welfare-system/export_contributions",
      { page, limit, search, status },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    // Expect backend to return { status: true, download_url: "https://..." } or file path
    if (res.data?.status && res.data?.download_url) {
      return { success: true, download_url: res.data.download_url };
    }
    // fallback: if response returns a direct file blob, you must handle differently
    return { success: false, error: res.data?.message || "Export failed" };
  } catch (err) {
    return {
      success: false,
      error: err.response?.data?.message || err.message || "Server error",
    };
  }
};

//add contribution
// Add this new function for ADMIN to add contributions
export const addContribution = async (memberId, amount, category, adminId) => {
  try {
    const token = getToken();
    
    // Log the request details for debugging
    console.log("Sending contribution request:", {
      memberId,
      amount,
      category,
      token: token ? "Present" : "Missing"
    });
    
    const response = await API.post(
      `/welfare/welfare-system/add-contribution`,
      {
        amount,
        category,
        member_id: memberId,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Add contribution response:", response.data);
    return response.data;
  } catch (err) {
    console.error("Admin add contribution failed:", {
      message: err.message,
      response: err.response?.data,
      status: err.response?.status,
      statusText: err.response?.statusText,
      config: {
        url: err.config?.url,
        method: err.config?.method,
        data: err.config?.data
      }
    });
    
    // Throw a more informative error
    throw new Error(
      err.response?.data?.message || 
      err.message || 
      "Failed to add contribution"
    );
  }
};
